module.exports = __webpack_public_path__ + "static/media/files-medical.e970bb78.svg";